/* eslint-disable */
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import styles from './tableComponent.module.scss';
import deleteIcon from '../../../Assets/images/svg/dar_delete.svg';
import editIcon from '../../../Assets/images/svg/dar_edit.svg';
import PropTypes from 'prop-types';
import AddIcon from '@mui/icons-material/Add';

const TableComponent = ({
  headers,
  data,
  onDeleteRow,
  onEditRow,
  openAddRowDialog,
  rowType,
  hasAccess,
}) => {
  const getUpdatedValue = (key, value, rowType) => {
    if (rowType === 'projectTable' && (key === 'to' || key === 'from')) {
      return `${value} Man Days`;
    } else if (rowType === 'testTable' && key === 'is_mandatory') {
      if (value === true) {
        return 'Mandatory';
      } else {
        return 'Optional';
      }
    } else if (key === 'percentage') {
      return `${value} %`;
    } else if (key === 'to' || key === 'from') {
      return `${value} %`;
    } else {
      return value;
    }
  };
  return (
    <div>
      <TableContainer component={Paper} className={styles.tableContainer}>
        <Table className={styles.table} sx={{ overflowX: 'auto' }}>
          <TableHead className={styles.tableHead}>
            <TableRow className={styles.tableRow}>
              {headers.map((header) => (
                <TableCell
                  key={header.label}
                  align={header.align || 'left'}
                  className={styles.tableCell}
                >
                  <div className={styles.headers}>{header.label}</div>
                </TableCell>
              ))}
              <TableCell align="center" className={styles.actionsCell}>
                <div className={styles.headers}>Actions</div>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, rowIndex) => (
              <TableRow
                key={row.id}
                className={styles.tableBodyRow}
                style={{
                  backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F1F5F8',
                }}
              >
                {headers.map((header) => (
                  <TableCell
                    key={header?.key}
                    align={header.align || 'left'}
                    className={styles.tableBodyCell}
                  >
                    <div className={styles.cells}>
                      {getUpdatedValue(header.key, row[header.key], rowType)}
                    </div>
                  </TableCell>
                ))}
                <TableCell align="center" className={styles.actionsCell}>
                  <button
                    onClick={() => onEditRow(row.id)}
                    className={styles.actionsButton}
                    disabled={!hasAccess('update')}
                  >
                    <img
                      src={editIcon}
                      className={styles.actionsIcon}
                      alt="edit"
                    />
                  </button>
                  <button
                    onClick={() => onDeleteRow(row.id)}
                    className={styles.actionsButton}
                    disabled={!hasAccess('delete')}
                  >
                    <img
                      src={deleteIcon}
                      className={styles.actionsIcon}
                      alt="delete"
                    />
                  </button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <div className={styles.addRowContainer}>
          <button
            disabled={!hasAccess('create')}
            onClick={() => openAddRowDialog(rowType)}
            className={styles.addRowButton}
          >
            <AddIcon sx={{ fontSize: 18 }} />
            <div className={styles['add-row-text']}>Add row</div>
          </button>
        </div>
      </TableContainer>
    </div>
  );
};

TableComponent.propTypes = {
  headers: PropTypes.any,
  data: PropTypes.any,
  onDeleteRow: PropTypes.any,
  onEditRow: PropTypes.any,
  openAddRowDialog: PropTypes.any,
  rowType: PropTypes.any,
  hasAccess: PropTypes.func.isRequired,
};
export default TableComponent;
